import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-multi-date-picker";
import { secretKey } from "./data";
import "./app.css";

const MySwal = withReactContent(Swal2);

const AcceptHoliday = (props) => {
  const acceptHoliday = async (id) => {
    var body = {
      id: id,
    };

    await fetch("https://apisplit.ftpeople.pl/acceptHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Zaakceptowano",
      text: "wniosek urlopowy",
    }).then((result) => {
      props.close();
    });
  };

  const deleteHoliday = async (id) => {
    var body = {
      id: id,
    };

    await fetch("https://apisplit.ftpeople.pl/deleteHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "wniosek urlopowy",
    }).then((result) => {
      props.close();
    });
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "10vh",
          right: "0",
          marginRight: "20px",
          padding: "20px",
          backgroundColor: "white",
          width: "80vw",
          boxShadow: "rgb(66, 68, 90) -8px 0px 24px 0px",
          borderRadius: "15px",
          minHeight: "30vh",
          zIndex: "2",
          overflowY: "scroll",
          paddingBottom: "20px",
        }}
      >
        <div className="closeBox" style={{ paddingBottom: "10px" }}>
          <button
            style={{
              width: "30px",
              textAlign: "center",
              backgroundColor: "red",
              color: "white",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={props.close}
          >
            X
          </button>
          <div>
            <p
              style={{
                textAlign: "left",
                fontSize: "1.5vw",
                fontWeight: "600",
              }}
            >
              WNIOSKI URLOPOWE DO AKCEPTACJI
            </p>
            {props.holidaysData.length > 0 ? (
              <table style={{ marginTop: "0vh" }} className="clients_table">
                <tr key={0}>
                  <th style={{ textAlign: "center" }}>Pracownik</th>
                  <th style={{ textAlign: "center" }}>Data od</th>
                  <th style={{ textAlign: "center" }}>Data do</th>
                  <th style={{ textAlign: "center" }}>Akcja</th>
                </tr>
                {props.holidaysData
                  .sort(function (a, b) {
                    return new Date(a.date_from) - new Date(b.date_from);
                  })
                  .map((el, index) => (
                    <>
                      <tr id={""} key={el.id}>
                        <td>{el.user}</td>
                        <td>{el.date_from}</td>
                        <td>{el.date_to}</td>
                        <td
                          style={{
                            width: "20%",
                            minWidth: "200px",
                            lineBreak: "none",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "5px",
                              padding: "10px 0px",
                            }}
                          >
                            <button
                              className="loginButtonLogin"
                              value={el.id}
                              style={{
                                margin: "0",
                                backgroundColor: "green",
                                borderColor: "green",
                                width: "45%",
                                fontSize: ".6vw",
                              }}
                              onClick={(e) => {
                                acceptHoliday(e.target.value);
                              }}
                            >
                              akceptuj
                            </button>
                            <button
                              className="loginButtonLogin"
                              value={el.id}
                              style={{
                                margin: "0",
                                backgroundColor: "red",
                                borderColor: "red",
                                color: "white",
                                width: "45%",
                                fontSize: ".6vw",
                              }}
                              onClick={(e) => {
                                deleteHoliday(e.target.value);
                              }}
                            >
                              usuń
                            </button>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            ) : (
              <p style={{ textAlign: "left" }}>brak wniosków do akceptacji</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AcceptHoliday;
